export default "__VITE_ASSET__DuVE8l1$__"